import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=e4abdace&"
import script from "./formItem.vue?vue&type=script&lang=js&"
export * from "./formItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4abdace')) {
      api.createRecord('e4abdace', component.options)
    } else {
      api.reload('e4abdace', component.options)
    }
    module.hot.accept("./formItem.vue?vue&type=template&id=e4abdace&", function () {
      api.rerender('e4abdace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/components/formItem.vue"
export default component.exports